export default "__VITE_ASSET__BZMmp8nJ__"